export default [{
    path: '/order/transactionDetails',
    name: 'transactionDetails',
    meta: {
      index: 4
    },
    component: () => import('@/views/order/transactionDetails.vue')
  }]
  